import React, { createContext, useContext, useState } from 'react'

const Context = createContext()

const AuthContext = ({ children }) => {
  const UserData = window.localStorage.getItem('user')
  const [user, setuser] = useState(JSON.parse(UserData) || null)


  const login = (data) => {
    setuser(data)
    window.localStorage.setItem('user', JSON.stringify(data))
  }

  const logout = () => {
    setuser(null)
    window.localStorage.removeItem('user')
  }

  return (
    <Context.Provider value={{ user, login, logout }}>{children}</Context.Provider>
  )
}

export const useAuthContext = () => useContext(Context)

export default AuthContext
